import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from "./constants";

dayjs.extend(updateLocale);
dayjs.extend(timezone);
dayjs.extend(utc);

const getTimezone = () => dayjs.tz.guess();

const getTimeAndDate = dateObject => {
  const currentTimezone = getTimezone();
  const time = dateObject.tz(currentTimezone).format(DEFAULT_TIME_FORMAT);
  const date = dateObject.tz(currentTimezone).format(DEFAULT_DATE_FORMAT);

  return { time, date };
};

const updateDurationBaseStrings = () => {
  dayjs.updateLocale("en", {
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      m: "a minute",
      mm: "%d minutes",
      hh: "%d hours",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years",
      h: "1 hour",
      d: "24 hours",
    },
  });
};

export { getTimezone, getTimeAndDate, updateDurationBaseStrings };
